var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"fea469ae526c54ab0a8b98b242ddfac705e44b43"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["prom@nicholas-gregory"]={id:"fea469ae526c54ab0a8b98b242ddfac705e44b43"};
      